import React, { useEffect, useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import Layout from '../Layout';
import { GeneralityHeader, MessageViewModal, ConfirmResponseModal } from './GeneralityComponent';
import '../orders/Order.css';
import { MessageApi } from '../../app/api/message.api';
import { formatDateTime } from '../orders/OrderComponent';


export function Message() 
{
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);

  const [object, seCategory] = useState("");
  const [isReplied, setIsReplied] = useState("");
  const [month, setMonth] = useState("");

  
  const message = MessageApi(); 
  const [filteredData, setFilteredData] = useState([]);
    
  const fetchData = async () => { 
    const {data} = await message.findAll();
    return data.data; 
  }
  const { isLoading, data=[], error, refetch } = useQuery({  queryKey: ["messages"], queryFn: fetchData });
    
    
  const handleInputs = (event) => {
    const { name, value } = event.target;
    if( name === 'object' ) {
        seCategory(value);
    }
    if (name === "isReplied") {
      if (value === "") {
        setIsReplied("");
      } else {
      setIsReplied(value === "true"); // conversion string -> boolean
      }
    }
    if( name === 'month' ) {
        setMonth(value);
    }
  }
  
  useEffect(() => {
    
    if (!Array.isArray(data)) return;
    let filtered = data;
    
    // Filtre status (boolean)
    if (isReplied !== "") {
      filtered = filtered.filter(item => item.isReplied === isReplied);
    }

    // Filtre objet
    if (object !== "") {
      filtered = filtered.filter(item =>
        item.object?.toLowerCase().includes(object.toLowerCase())
      );
    }

    // Filtre mois (format YYYY-MM)
    if (month !== "") {
      filtered = filtered.filter(item =>
        item.createdAt?.startsWith(month)
      );
    }
       
    setFilteredData(filtered);
    
  }, [data, object, isReplied, month]);  
  

  const handleOpenMessage = (message) => {
    setSelectedMessage(message);
    setShowMessageModal(true);
  };

  const handleOpenConfirmation = (message) => {
    setSelectedMessage(message);
    setShowResponseModal(true);
  };


  return (

    <Layout activeMenu={5}>
  
      <div className='container-fluid'>
        <div className='row justify-content-center pt-4'>
          <div className='col-md-11'>
                
            <section className='row' >
              <GeneralityHeader active={1} />
            </section>

            <section className='row'> 
                <div className="d-flex gap-3 flex-column flex-md-row justify-content-between align-items-center border-bottom pb-3 mb-4">
                   {/* Vue Grille/Liste */}
                   <div className="d-flex align-items-center gap-3 display-controls">
                     <span className="text-muted lead"><i className="bi bi-grid-3x3-gap-fill"></i></span>
                     <span className="text-muted lead"> Liste des messages </span>
                   </div>
                    {/* Infos et Tris */}
                   <div className="d-flex align-items-center gap-3 filter-controls">
                      <span className="text-muted small"> { filteredData.length } effectif(s) </span>
                   </div>
                </div>

                {/* Boutons de Filtres Catégories */}
                <div className="d-flex gap-2 flex-wrap mb-5">
                  <div className="dropdown">
                    <select className="w-100 text-muted px-3 py-1 border" value={object} name="object" onChange={ handleInputs } >
                      <option value="" > Sélectionner l'objet du message </option>
                      <option value="objet 1" > Objet 1 </option>
                      <option value="objet 2" > Objet 2 </option>
                      <option value="objet 3" > Objet 3 </option>
                    </select>
                  </div>
                <div className="dropdown">
                    <select className="w-100 text-muted px-3 py-1 border" value={isReplied === "" ? "" : isReplied.toString()} name="isReplied" onChange={ handleInputs }  >
                       <option value=""> Sélectionner le status </option>
                       <option value="false"> Pas répondu </option>
                       <option value="true"> Répondu </option>
                    </select>
                  </div>
                  <div className="d-flex align-items-center" >
                    <input type="month" className="w-100 px-3 py-1 border" value={month} name="month" onChange={ handleInputs } />         
                  </div>
                </div>
            </section>

            {/* ________________ MESSAGE ________________ */}

            <section className="row mb-4">
              {/* Loading */}
              {isLoading && (
                <div className="d-flex flex-column align-items-center mt-4">
                  <div className="spinner-border mb-3" style={{ width: '5rem', height: '5rem', color: '#307072' }}></div>
                  <p className="text-secondary"> Chargement de données en cours...</p>
                </div>
              )}
              
              {/* Error */}
              {!isLoading && error && (
                <div className="text-center p-4 border alert alert-danger w-100">
                  Une erreur est survenue. Veuillez vérifier votre connexion.
                </div>
              )}

              {/* Data */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length > 0 && (

                filteredData.map( ( item, index ) => (

                    <div className="col-lg-12 px-0" key={index}>
                        <div className="d-flex gap-3 p-3 flex-column flex-lg-row justify-content-between border mb-3">
                          <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center justify-content-center text-secondary me-2 pe-3">
                                 {
                                    item?.isReplied ? (  <i className="bi bi-star-fill text-warning lead"> </i>  ) : (  <i className="bi bi-star lead"> </i>  )
                                }
                               
                            </div>
                            <div>
                              <div className="d-flex align-items-center text-secondary small gap-2" title={ 'Objet du message' }>
                                <span className="fw-bold"> Objet : { item?.object } </span>
                                {
                                    item?.isReplied && ( <span className="bg-light border px-2 text-green"> répondu </span> )
                                }
                              </div>
                              <div className="text-secondary small" title={ 'email' }> { item?.email } </div>
                              <div className="text-secondary small" title={ 'date' }> { formatDateTime( item?.createdAt ) } </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            {
                               ! item.isReplied && (
                                  <button title="Confirmer la réponse" className="btn btn-sm rounded-0 btn-outline-green px-2 mt-2" onClick={() => handleOpenConfirmation(item)}>
                                    Statuer <i className="bi bi-pencil"> </i> 
                                  </button>
                               )
                            }
                            <button title="Lire le message" className="btn btn-sm rounded-0 btn-outline-dark px-2 mt-2" onClick={() => handleOpenMessage(item)}>
                               Ouvrir <i className="bi bi-box-arrow-up-right"> </i> 
                            </button>     
                          </div>

                        </div>
                    </div>
                ))
              )} 

              { /* Liste vide */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length === 0 && (
                <div className="bg-white border p-4 text-center text-secondary w-100">
                  La liste est actuellement vide. Aucun élément n’a été trouvé.
                </div>
              )}

            </section>

          </div>   
        </div>
      </div>

      {/* Message popup */}
      {
        showMessageModal && (
            <MessageViewModal show={showMessageModal} onHide={() => setShowMessageModal(false)}  message={selectedMessage} />
        )
      }
      {/* Confirmation popup */}
      {
        showResponseModal && (
            <ConfirmResponseModal show={showResponseModal} onHide={() => setShowResponseModal(false)} messageItem={selectedMessage} refetch={refetch} />
        )
      }
      
    </Layout>

  );
        
}